    <div class="ibox ">
     <iboxtools
        [Title]=""
        [DateInit]=""
        [DateEnd]=""
        [isHistory]=false
        [IsEditing]="isEditing"
        (EditChange)="EditChange($event)"
        (SaveChange)="SaveChange($event)"
        (CancelChange)="CancelChange($event)"
        [Permiso]="permisoEdicion"
    ></iboxtools>
        <div class="ibox-content">
            <mat-error *ngIf="datosInvalida" class="datosInvalida">{{MensajeError}}</mat-error>
            <form [formGroup]="datosPersonalesForm">
                <div class="row" hidden="true">
                    <input formControlName="id" name ="id" type="text" class="form-control" />
                </div>
                
                <div class="row">
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Legajo</label>
                        <input formControlName="legajo" name ="selectedLegajo" type="text" class="form-control" readonly/>
                    </div>
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">ID Fiscal</label>
                        <input formControlName="IDfiscal" name ="selectedIdFiscal" type="text" class="form-control" [ngClass]="{ 'is-invalid': f.IDfiscal.errors }" />
                        <div *ngIf="f.IDfiscal.errors" class="text-danger">
                            <div *ngIf="f.IDfiscal.errors.required">El CUIT/CUIL del Empleado es Requerido</div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <label class="col-form-label font-bold" for="fecNacimiento">Fecha de Nacimiento</label>
                        <p-calendar appendTo="body" selectOtherMonths="true" #fecNacimiento formControlName="fecNacimiento" required dateFormat="dd/mm/yy" inputId="fecNacimiento" ngDefaultControl [ngClass]="{ 'is-invalid': f.fecNacimiento.errors }"></p-calendar>
                        <div *ngIf="f.fecNacimiento.invalid && (f.fecNacimiento?.dirty || f.fecNacimiento?.touched)" class="text-danger">                            
                            <div *ngIf="f.fecNacimiento.errors?.required">La Fecha de Nacimiento es Requerida</div>
                            <div *ngIf="f.fecNacimiento.errors?.isYounger">El Empleado es Menor de Edad</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Nombre</label>
                        <input formControlName="nombre" name ="selectedNombre" type="text" class="form-control" [ngClass]="{ 'is-invalid': f.nombre.errors }" />
                        <div *ngIf="f.nombre.errors" class="text-danger">
                            <div *ngIf="f.nombre.errors.required">El Nombre del Empleado es Requerido</div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Apellido</label>
                        <input formControlName="apellido" name ="selectedApellido" type="text" class="form-control" [ngClass]="{ 'is-invalid': f.apellido.errors }" />
                        <div *ngIf="f.apellido.errors" class="text-danger">
                            <div *ngIf="f.apellido.errors.required">El Apellido del Empleado es Requerido</div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Segundo Apellido</label>
                        <input formControlName="segundoApellido" name ="selectedSApellido" type="text" class="form-control" [ngClass]="{ 'is-invalid': f.segundoApellido.errors }" />                        
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Nacionalidad</label>
                        <div>
                        <comboTools
                            [list]=paisesList
                            selected='nacionalidad'
                            [isEditing]=disabledEditing
                            [formParent]="datosPersonalesForm"
                            filter="descripcion"
                        ></comboTools>
                        </div>
                    </div>
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Idioma</label>
                        <div>
                        <comboTools
                            [list]=idiomasList
                            selected='idioma'
                            [formParent]="datosPersonalesForm"
                            [isEditing]=disabledEditing
                            filter="descripcion"
                        ></comboTools>
                        </div>
                    </div>
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Estado Civil</label>
                        <div>
                        <comboTools
                            [list]=estadoCivilList
                            [formParent]="datosPersonalesForm"
                            selected='estadoCivil'
                            [isEditing]=disabledEditing
                            filter="descripcion"
                        ></comboTools>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Tratamiento</label>
                        <div>
                        <comboTools
                            [list]=tratamientosList
                            [formParent]="datosPersonalesForm"
                            selected='tratamiento'
                            [isEditing]=disabledEditing
                            soloDescri=true
                            filter="descripcion"
                        ></comboTools>
                        </div>

                    </div>
                    
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Sexo</label>
                        <div>
                        <comboTools
                            [list]=sexosList
                            [formParent]="datosPersonalesForm"
                            selected='sexo'
                            [isEditing]=disabledEditing
                            filter="descripcion"
                        ></comboTools>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Email</label>
                        <input formControlName="email" name ="selectedMail" type="text" class="form-control" [ngClass]="{ 'is-invalid': f.email.errors }"/>
                        <div *ngIf="f.email.invalid && (f.email?.dirty || f.email?.touched)" class="text-danger">
                            <div *ngIf="f.email.errors?.required">El E-Mail del Empleado es Requerido</div>
                            <div *ngIf="f.email.errors?.email">El Email es Invalido</div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <label class=" col-form-label font-bold">Teléfono</label>
                        <input formControlName="celular" name ="selectedCelular" type="text" class="form-control" [ngClass]="{ 'is-invalid': f.celular.errors }"/>
                        <div *ngIf="f.celular.invalid && (f.celular?.dirty || f.celular?.touched)" class="text-danger">
                            <div *ngIf="f.celular.errors?.required">El Teléfono del Empleado es Requerido</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
